import { V1RequestStatus } from '@/lib/api/lib/models'

type StatusConfigEntry = {
    color: string
    label: string
}

export const statusConfig: Record<string, StatusConfigEntry> = {
    [V1RequestStatus.PendingPayment]: {
        color: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300',
        label: 'requests.status.pendingPayment'
    },
    [V1RequestStatus.Requested]: {
        color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
        label: 'requests.status.requested'
    },
    [V1RequestStatus.Accepted]: {
        color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
        label: 'requests.status.accepted'
    },
    [V1RequestStatus.InProgress]: {
        color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
        label: 'requests.status.inProgress'
    },
    [V1RequestStatus.Delivered]: {
        color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
        label: 'requests.status.delivered'
    },
    [V1RequestStatus.Completed]: {
        color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
        label: 'requests.status.completed'
    },
    [V1RequestStatus.Rejected]: {
        color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
        label: 'requests.status.rejected'
    },
    [V1RequestStatus.Disputed]: {
        color: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300',
        label: 'requests.status.disputed'
    },
    [V1RequestStatus.Abandoned]: {
        color: 'bg-gray-100 text-gray-600 dark:bg-gray-800/30 dark:text-gray-400',
        label: 'requests.status.abandoned'
    },
    [V1RequestStatus.Refunded]: {
        color: 'bg-gray-100 text-gray-600 dark:bg-gray-800/30 dark:text-gray-400',
        label: 'requests.status.refunded'
    }
}

export function formatRequestDate(
    epoch?: number,
    options?: { includeTime?: boolean }
): string {
    if (!epoch) return ''
    return new Date(epoch * 1000).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        ...(options?.includeTime
            ? { hour: '2-digit' as const, minute: '2-digit' as const }
            : {})
    })
}

export function formatRequestDateTime(epoch?: number): string {
    return formatRequestDate(epoch, { includeTime: true })
}
